import "./style.css";
import React, { useContext } from 'react';
import { Helmet, HelmetProvider } from "react-helmet-async";
import Typewriter from "typewriter-effect";
import { section_home, meta } from "../../content_option";
import { Link } from "react-router-dom";
import { LanguageContext } from '../../data/language_context';

// Helper function to generate the correct key for section_about lookups
const getLangKey = (selectedLang) => {
  switch (selectedLang) {
    case "Spanish": return "_esp";
    case "Catalan": return "_cat";
    case "English":
    default: return "_eng";
  }
};

export const Home = () => {
  const { language: selectedLang } = useContext(LanguageContext);
  const langSuffix = getLangKey(selectedLang); // Determine suffix once

  // Helper function to select text by language from section_about
  const t = (baseKey) => {
    return section_home[`${baseKey}${langSuffix}`];
  };

  return (
    <HelmetProvider>
      <section id="home" className="home">
        <Helmet>
          <meta charSet="utf-8" />
          <link rel="icon" href={meta.logo} />
          <title> {meta.title}</title>
          <meta name="description" content={meta.description} />
        </Helmet>
        <div className="intro_sec d-block d-lg-flex align-items-center ">
          <div
            className="h_bg-image order-1 order-lg-2 h-100 "
            style={{ backgroundImage: `url(${section_home.backgroundImagePath})` }}
          ></div>
          <div className="text order-2 order-lg-1 h-2500 d-lg-flex justify-content-center">
            <div className="align-self-center ">
              <div className="intro mx-auto">
                <h2 className="mb-1x">{section_home.title}</h2>
                <h1 className="fluidz-48 mb-1x">
                  <Typewriter
                    options={{
                      strings: [
                        t("animated").first,
                        t("animated").second,
                        t("animated").third,
                        t("animated").fourth,
                        t("animated").fifth,
                      ],
                      autoStart: true,
                      loop: true,
                      deleteSpeed: 10,
                    }}
                  />
                </h1>
                <p className="mb-1x">{t("description")}</p>
                <div className="intro_btn-action pb-5">
                  <Link to="/b2b" className="text_1">
                    <div id="button_1" className="ac_btn btn">
                      {t("button1")}
                      <div className="ring one"></div>
                      <div className="ring two"></div>
                      <div className="ring three"></div>
                    </div>
                  </Link>
                  <Link to="/b2c" className="text_2">
                    <div id="button_2" className="ac_btn btn">
                      {t("button2")}
                      <div className="ring one"></div>
                      <div className="ring two"></div>
                      <div className="ring three"></div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </HelmetProvider>
  );
};
